import {useEffect, useRef} from "react";

import {postApplicationApi} from "@/features/applications/api/post_application";
import {getLeadMutationCacheKey} from "@/features/lead/utils/get_lead_mutation_cache_key";
import {trackLeadUserComAttributes} from "@/features/lead/utils/track_lead_user_com_attributes";
import {addNotification} from "@/features/notifications/state/notifications_slice";
import {defaultAPIErrorNotification} from "@/features/notifications/utils/error_notifications";
import {useAppDispatch} from "@/store/hooks/use_app_dispatch";
import {useAppSelector} from "@/store/hooks/use_app_selector";
import {assertNever} from "@/utils/assert_never";

import {useHomeMatchPreferences} from "../../hooks/use_home_match_preferences";
import {PhoneVerificationFlowStatusType} from "../../interfaces/PhoneVerificationFlowStatusType";
import {completePendingAction, selectPendingAction, selectPhoneVerificationFlowStatus} from "../../state/user_phone_verification_slice";
import {PhoneVerificationPendingActionType} from "../types/phone_verification_types";

export const usePhoneVerificationActionExecutor = () => {
    const dispatch = useAppDispatch();
    const phoneVerificationFlowStatus = useAppSelector(selectPhoneVerificationFlowStatus);
    const pendingAction = useAppSelector(selectPendingAction);
    const {switchHomeMatchPreferences} = useHomeMatchPreferences();
    const isExecutingRef = useRef(false);

    useEffect(() => {
        if (phoneVerificationFlowStatus !== PhoneVerificationFlowStatusType.SUCCESS || isExecutingRef.current) return;

        isExecutingRef.current = true;

        const executePendingAction = async () => {
            const pendingActionType = pendingAction.type;

            try {
                switch (pendingAction.type) {
                    case PhoneVerificationPendingActionType.NONE: {
                        return dispatch(completePendingAction({success: true}));
                    }
                    case PhoneVerificationPendingActionType.LEAD_SEND: {
                        const {leadPayload} = pendingAction;

                        trackLeadUserComAttributes({name: leadPayload.name, phone: leadPayload.phone});

                        await dispatch(
                            postApplicationApi.endpoints.postApplication.initiate(leadPayload, {
                                fixedCacheKey: getLeadMutationCacheKey(leadPayload)
                            })
                        ).unwrap();

                        return dispatch(completePendingAction({success: true}));
                    }
                    case PhoneVerificationPendingActionType.HM_ACTIVATION: {
                        const {hmActivationIntent} = pendingAction;

                        const isSaved = await switchHomeMatchPreferences(hmActivationIntent.isActive, {
                            syncCplPreferences: hmActivationIntent.syncCplPreferences,
                            sourceSection: hmActivationIntent.sourceSection,
                            showSuccessNotification: hmActivationIntent.showSuccessNotification,
                            skipPhoneVerificationPrompt: true
                        });

                        return dispatch(completePendingAction({success: isSaved}));
                    }
                    case PhoneVerificationPendingActionType.REGISTRATION_ONBOARDING: {
                        return dispatch(completePendingAction({success: true}));
                    }
                    default: {
                        return assertNever(pendingAction);
                    }
                }
            } catch {
                if (pendingActionType === PhoneVerificationPendingActionType.LEAD_SEND) dispatch(addNotification(defaultAPIErrorNotification));
                return dispatch(completePendingAction({success: false}));
            } finally {
                isExecutingRef.current = false;
            }
        };

        void executePendingAction();
    }, [dispatch, pendingAction, phoneVerificationFlowStatus, switchHomeMatchPreferences]);
};
import {useEffect, useRef} from "react";

import {postApplicationApi} from "@/features/applications/api/post_application";
import {getLeadMutationCacheKey} from "@/features/lead/utils/get_lead_mutation_cache_key";
import {trackLeadUserComAttributes} from "@/features/lead/utils/track_lead_user_com_attributes";
import {addNotification} from "@/features/notifications/state/notifications_slice";
import {defaultAPIErrorNotification} from "@/features/notifications/utils/error_notifications";
import {useAppDispatch} from "@/store/hooks/use_app_dispatch";
import {useAppSelector} from "@/store/hooks/use_app_selector";
import {assertNever} from "@/utils/assert_never";

import {useHomeMatchPreferences} from "../../hooks/use_home_match_preferences";
import {PhoneVerificationFlowStatusType} from "../../interfaces/PhoneVerificationFlowStatusType";
import {completePendingAction, selectPendingAction, selectPhoneVerificationFlowStatus} from "../../state/user_phone_verification_slice";
import {PhoneVerificationPendingActionType} from "../types/phone_verification_types";

export const usePhoneVerificationActionExecutor = () => {
    const dispatch = useAppDispatch();
    const phoneVerificationFlowStatus = useAppSelector(selectPhoneVerificationFlowStatus);
    const pendingAction = useAppSelector(selectPendingAction);
    const {switchHomeMatchPreferences} = useHomeMatchPreferences();
    const isExecutingRef = useRef(false);

    useEffect(() => {
        if (phoneVerificationFlowStatus !== PhoneVerificationFlowStatusType.SUCCESS || isExecutingRef.current) return;

        isExecutingRef.current = true;

        const executePendingAction = async () => {
            const pendingActionType = pendingAction.type;

            try {
                switch (pendingAction.type) {
                    case PhoneVerificationPendingActionType.NONE: {
                        return dispatch(completePendingAction({success: true}));
                    }
                    case PhoneVerificationPendingActionType.LEAD_SEND: {
                        const {leadPayload} = pendingAction;

                        trackLeadUserComAttributes({name: leadPayload.name, phone: leadPayload.phone});

                        await dispatch(
                            postApplicationApi.endpoints.postApplication.initiate(leadPayload, {
                                fixedCacheKey: getLeadMutationCacheKey(leadPayload)
                            })
                        ).unwrap();

                        return dispatch(completePendingAction({success: true}));
                    }
                    case PhoneVerificationPendingActionType.HM_ACTIVATION: {
                        const {hmActivationIntent} = pendingAction;

                        const isSaved = await switchHomeMatchPreferences(hmActivationIntent.isActive, {
                            syncCplPreferences: hmActivationIntent.syncCplPreferences,
                            sourceSection: hmActivationIntent.sourceSection,
                            showSuccessNotification: hmActivationIntent.showSuccessNotification,
                            skipPhoneVerificationPrompt: true
                        });

                        return dispatch(completePendingAction({success: isSaved}));
                    }
                    case PhoneVerificationPendingActionType.REGISTRATION_ONBOARDING: {
                        return dispatch(completePendingAction({success: true}));
                    }
                    default: {
                        return assertNever(pendingAction);
                    }
                }
            } catch {
                if (pendingActionType === PhoneVerificationPendingActionType.LEAD_SEND) dispatch(addNotification(defaultAPIErrorNotification));
                return dispatch(completePendingAction({success: false}));
            } finally {
                isExecutingRef.current = false;
            }
        };

        void executePendingAction();
    }, [dispatch, pendingAction, phoneVerificationFlowStatus, switchHomeMatchPreferences]);
};
